export function normalizeWebsite(value: string | null | undefined): string {
  const trimmed = (value ?? '').trim();
  if (!trimmed) {
    return '';
  }
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

export function isValidWebsite(value: string | null | undefined): boolean {
  const normalized = normalizeWebsite(value);
  if (!normalized) {
    return false;
  }
  try {
    const url = new URL(normalized);
    return url.hostname.includes('.');
  } catch {
    return false;
  }
}
